module.exports = "<div class=\"alert alert-danger fade in\"> <a href=# class=close data-dismiss=alert aria-label=close title=close>×</a> <strong>server error occurred!</strong> You offer haven't successfully sent, please contact our tech support via <a href=mailto:support@wildcardparking.com>support@wildcardparking.com</a> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/iframes/errorBox.html
 ** module id = 1
 ** module chunks = 0
 **/